import { combineReducers } from "redux";
import { reducer as userReducer, UserState } from "../user";
import { reducer as metricsReducer, MetricsState } from "../logging";
import subheaderSlice, {
  SubheaderState,
} from "../layout/subheader/subheaderSlice";
import helpPanelSlice, { HelpPanelState } from "../help_panel/helpPanelSlice";
import bannerSlice, { BannerState } from "../banner/bannerSlice";

export interface RootState {
  user: UserState;
  metrics: MetricsState;
  subheader: SubheaderState;
  helpPanel: HelpPanelState;
  banner: BannerState;
}

const rootReducer = combineReducers<RootState>({
  user: userReducer,
  metrics: metricsReducer,
  subheader: subheaderSlice.reducer,
  helpPanel: helpPanelSlice.reducer,
  banner: bannerSlice.reducer,
});

export default rootReducer;
